import { Box, SxProps, Typography } from '@mui/material';

const container: SxProps = {
  border: 'solid',
  borderWidth: 1,
  borderColor: '#D8D8D8',
  py: '2px',
  px: '6px'
};

type Props = {
  containerProps?: SxProps;
  value: string;
};

const BoxedLabel: React.FC<Props> = ({ containerProps, value }) => {
  return (
    <Box
      sx={{
        ...container,
        ...containerProps
      }}
    >
      <Typography variant="caption">{value}</Typography>
    </Box>
  );
};

export { BoxedLabel };
